<template>
  <div :class='statusCheck()'  :data-percent='performance'>
    <svg class="progress" width="178" height="178" viewport="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <circle r="81" cx="89" cy="89" fill="transparent" stroke-dasharray="502.4" stroke-dashoffset="0" ></circle>
      <circle class="bar" r="81" cx="89" cy="89" fill="transparent" stroke-dasharray="502.4" stroke-dashoffset="0"></circle>
    </svg>
  </div>
</template>

<script>

import { profileBar } from '@/common/jQuery';

export default {
  name: 'achievements-circle',
  props: ['performance'],
  data() {
    return {};
  },
  mounted() {
    profileBar();
  },
  methods: {
    statusCheck() {
      if (this.performance === 100.00 || this.performance === 100) {
        return 'progressdiv small complete';
      }
      return 'progressdiv small';
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/home/profile/AchievementsCircle.vue